var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"mt-5"},[(_vm.error)?[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(_vm._s(_vm.error))])]:_c('p',{staticClass:"text-center"},[_vm._v(" Counting backwards from infinity... ")])],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }